"use client"

import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { LoadingAnimation } from "./loading"

export const LinkLoadingIndicatorWrapper = () => {
    const pathname = usePathname()
    const [isLoading, setIsLoading] = useState(false)
  
    useEffect(() => {
      setIsLoading(true)
  
      const timeout = setTimeout(() => {
        setIsLoading(false)
      }, 500) // kb. fél másodpercig mutatjuk a loader-t, de lehet dinamikusabb is
  
      return () => clearTimeout(timeout)
    }, [pathname])
  
    return isLoading ? <LoadingAnimation /> : null
}
